// src/utils/snsPublisher.js
import { post } from '@aws-amplify/api';

export const publishToSNS = async (message) => {
  const operation = post({
    apiName: 'LocationFormRest',
    path: '/message',
    options: {
      body: message,
    },
  });

  return operation.response;
};

